import React from 'react'

function EnrolledCourse() {
  return (
    <div className='bg-richblack-900 h-[calc(100vh-3.5rem)] text-white'>
      
    </div>
  )
}

export default EnrolledCourse;